import { createContext, useContext } from 'react';
import type Pusher from 'pusher-js';

export type PusherConfig = {
  auth?: {
    headers?: Record<string, string>;
  };
  authEndpoint?: string;
  clientKey: string;
  cluster: string;
};

export type PusherConnectionState =
  | 'connected'
  | 'connecting'
  | 'disconnected'
  | 'failed'
  | 'initializing'
  | 'unavailable';

export type PusherContextValue = {
  config: PusherConfig;
  connectionState: PusherConnectionState;
  error: Error | null;
  isConnected: boolean;
  pusher: Pusher | null;
  reconnect: () => void;
};

export const PusherContext = createContext<PusherContextValue | undefined>(
  undefined
);

export const { Provider } = PusherContext;

export const usePusherContext = () => {
  const context = useContext(PusherContext);
  if (!context) {
    throw new Error(
      'usePusherContext must be used within a PusherContextProvider'
    );
  }
  return context;
};
